// 评价日期
export const commentDate = [
    {
        name: '今日',
        value: '0'
    },
    {
        name: '昨日',
        value: '1'
    },
    {
        name: '最近7天',
        value: '2'
    },
    {
        name: '最近30天',
        value: '3'
    }
]

// 评价星级
export const commentStar = [
    {
        name: '一星',
        value: '1'
    },
    {
        name: '二星',
        value: '2'
    },
    {
        name: '三星',
        value: '3'
    },
    {
        name: '四星',
        value: '4'
    },
    {
        name: '五星',
        value: '5'
    }
]



// WEBPACK FOOTER //
// ./src/data/comment-data.js